import Time from 'timen';

function throttle(fn, ms, { trailing, skipFirst } = {}) {
    let isCooldown = skipFirst;
    let isCalledAtCooldown = false;
    function runNext(...args) {
        Time.after(ms, () => {
            isCooldown = false;
            if (trailing && isCalledAtCooldown) {
                fn.apply(this, args);
                isCalledAtCooldown = false;
            }
        });
    }
    return function throttled(...args) {
        if (isCooldown) {
            if (!isCalledAtCooldown && skipFirst && trailing)
                runNext.apply(this, args);
            isCalledAtCooldown = true;
        }
        else {
            isCooldown = true;
            isCalledAtCooldown = false;
            fn.apply(this, args);
            runNext.apply(this, args);
        }
    };
}

export { throttle as default };
